import React from 'react';

export default function RightPanelTopInviteGuestWaitingArea(props) {
  return (
    <div className="ui actions mrbl  mrlnull pdlnull ">
      <button
        type="button"
        onClick={props.closeModal}
        className="ui cancel  left-text labeled icon button color-bad-things color-bad-things-hover color-white  max-width mrlnull"
      >
        <i className="remove  icon" />
        {APP.LANGUAGE.Close}
      </button>
    </div>
  );
}
